
import card from '~/mixins/card'
export default {
    mixins: [card],
    computed: {
        // the client's ICHRA administrator (e.g. SureCo), else their group's
        ichraTpa () {
            return (this.survey && this.survey.ichra_tpa) || this.$store.getters.groupIchraTpa || null
        },
    },
}
